import * as React from 'react';
import { useContext, useState, useEffect } from 'react';

import ModalDefault from './ModalDefault';
import Button from '../button/Button';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { CalendarPicker, CalendarPickerView } from '@mui/x-date-pickers/CalendarPicker';

import { ModalContext } from '../../provider/ModalProvider';
import { setLocaleDateString } from '../../utils/tools';
import { styled, Box } from '@mui/material';
import { d_flex, d_flex_center, dir_column } from '../../styles/common';
import dayjs from 'dayjs';

const CustomDatePicker = styled(CalendarPicker)(({ theme, view }) => {
  let year_style = {};
  let month_style = {};
  if (view === 'year') {
    year_style = {
      '& > div': {
        '&:first-of-type': {
          display: 'none',
        },
        '&:last-of-type': {
          '&::-webkit-scrollbar': {
            display: 'none',
          },
          '& > div': {
            '& > div': {
              display: 'flex',
              flexDirection: 'column-reverse',
              margin: '0',
              '&::-webkit-scrollbar': {
                display: 'none',
              },
              '& > div': {
                width: '100%',
                button: {
                  height: '3.25rem',
                  width: '100%',
                  borderRadius: '0',
                  margin: '0',
                  padding: '1rem 0',
                  fontSize: '1.2rem',
                  fontWeight: '500',
                  ...d_flex_center,
                  '&.Mui-selected': {
                    backgroundColor: '#e0e0e0',
                    color: theme.palette.black.main,
                  },
                },
              },
            },
          },
        },
      },
    };
  } else if (view === 'month') {
    month_style = {
      '& > div': {
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        '&:first-of-type': {
          position: 'relative',
          marginTop: '15px',
          '& > div': {
            '&:first-of-type': {
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              position: 'relative',
              right: '0.95rem',
              '& > div': {
                '&:first-of-type': {
                  width: '5rem',
                  textAlign: 'center',
                },
              },

              button: {
                display: 'none',
              },
            },
            '&:last-of-type': {
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              padding: '0 3rem',
              position: 'absolute',
              top: '50%',
              left: 0,
              transform: 'translateY(-50%)',
            },
          },
        },
        '&:last-of-type': {
          height: 'calc(100% - 30px)',
          '& > div': {
            height: '100%',
            '& > div': {
              height: '100%',
              button: {
                height: '25%',
                margin: '0',
                '&:hover': {
                  borderRadius: '0',
                },
                '&:disabled': {
                  color: '#cccccc',
                },
              },
            },
          },
        },
        '.PrivatePickersMonth-root.Mui-selected': {
          // backgroundColor: '#FF453B',
          borderRadius: '0',
          backgroundColor: 'transparent',
          color: 'rgba(0, 0, 0, 0.87)',

          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
          },
        },
      },
    };
  }
  return {
    '&.default_day': {
      '.MuiPickersDay-root': {
        '&.Mui-selected': {
          backgroundColor: 'transparent',
          color: 'rgba(0, 0, 0, 0.87)',

          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
          },
        },
      },
    },
    '&.account_stat': {
      '.MuiPickersDay-root': {
        '&.Mui-selected': {
          backgroundColor: '#FF453B',
          color: '#fff',

          '&:hover': {
            backgroundColor: 'FF453B',
          },
        },
      },
    },
    width: '24rem',
    height: '25.714rem',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '& > div': {
      '&::-webkit-scrollbar': {
        display: 'none',
      },
      fontSize: '1rem !important',
      '&:first-of-type': {
        position: 'relative',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        '& > div': {
          '&::-webkit-scrollbar': {
            display: 'none',
          },
          '&:first-of-type': {
            position: 'relative',
            right: '0.95rem',
            '&::-webkit-scrollbar': {
              display: 'none',
            },
            width: '100%',
            display: 'flex',
            justifyContent: 'center',

            '& > div': {
              '&::-webkit-scrollbar': {
                display: 'none',
              },
              '&:first-of-type': {
                '&::-webkit-scrollbar': {
                  display: 'none',
                },
                width: '5rem',
                textAlign: 'center',
              },
            },

            button: {
              display: 'none',
            },
          },
          '&:last-of-type': {
            '&::-webkit-scrollbar': {
              display: 'none',
            },
            width: '100%',
            height: 'auto',
            display: 'flex',
            justifyContent: 'space-between',
            padding: '0 0.5rem',
            position: 'absolute',
            top: '50%',
            left: 0,
            transform: 'translateY(-50%)',
            '& > button': {
              padding: '0',
              width: '2.5rem',
              height: '2.5rem',
              '&:disabled': {
                color: '#cccccc',
              },
            },
          },
        },
      },

      '.PrivatePickersSlideTransition-root': {
        minHeight: '238px',
        height: '238px',
      },
      '&:last-of-type': {
        height: 'calc(100% - 30px)',
        '& > div': {
          height: '100%',
          '& > div:first-of-type': {
            height: 'calc(20rem / 7)',
            gap: '0.1rem 0rem',
            '& > span': {
              width: 'calc(22.5rem / 7)',
              height: 'calc(18.75rem / 7)',
              fontSize: '1rem',
              margin: 0,
            },
          },
          '& > div:last-of-type': {
            height: 'calc(100% - 3rem)',
            '& > div': {
              '& > div': {
                margin: '0',
                gap: '0.1rem 0rem',
                '& > div': {
                  width: 'calc(22.5rem / 7)',
                  height: 'calc(18.75rem / 7)',
                  padding: '0 calc(1.875rem / 7)',
                  '& > div': {
                    width: 'calc(22.5rem / 7)',
                    height: 'calc(18.75rem / 7)',
                    fontSize: '1rem',
                    margin: 0,
                  },
                  '& > button': {
                    width: '100%',
                    height: '100%',
                    fontSize: '1rem',
                    margin: 0,
                    '&:disabled': {
                      color: '#cccccc',
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
    ...year_style,
    ...month_style,
    margin: '0',
  };
});

const StyledModalCalendar = styled(Box)(props => ({
  minWidth: '24rem',
  backgroundColor: props.theme.palette.white.main,
  ...d_flex_center,
  ...dir_column,

  '.timebox_wrap': {
    width: '100%',
    height: '358px',
    '.time_contents_box': {
      padding: '0 1rem 1rem',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '0.5rem',
      '& > div': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        height: 'calc(358px - 4.5rem)',
        overflowY: 'auto',

        '& > button': {
          minHeight: '2.5rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        width: '50%',
      },
    },

    '.timebox': {
      width: '100%',
      height: '4.5rem',
      padding: '0 1rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '0.5rem',
      button: {
        cursor: 'inherit',
        '&:hover': {
          backgroundColor: 'transparent',
          borderColor: 'rgba(119, 119, 119, 0.5)',
        },
        width: '50%',
      },
    },
  },
}));

const StyledTitle = styled(Box)(props => ({
  width: '100%',
  height: '6rem',
  backgroundColor: '#FF453B !important',
  color: props.theme.palette.white.main,
  padding: '0 1rem',
  justifyContent: 'center',
  ...d_flex,
  ...dir_column,
}));

const time_arr = ['오전', '오후'];
const hours_arr = [
  '00',
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
];
const minutes_arr = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];

function ModalCalendarStudent() {
  const { modal_calendar_year } = useContext(ModalContext);
  const [value, setValue] = useState<Date | null | unknown>(null);
  const [localeDate, setLocaleDate] = useState(setLocaleDateString(new Date(), 'kor'));
  const [view, setView] = useState<CalendarPickerView | undefined>('year');
  const [curYear, setCurYear] = useState('');
  const [modalTimeVisible, setModalTimeVisible] = useState(false);

  const [hours, setHours] = useState('00시');
  const [minutes, setMinutes] = useState('00분');
  const [statActive, setStatActive] = useState(false);

  const [dropdownEl, setDropdownEl] = useState<null | HTMLElement>(null);
  const [currentDropdownItems, setCurrentDropdownItems] = useState<{
    width: string;
    items: { id: string | number; label: string }[];
  }>({ width: '', items: [] });

  useEffect(() => {
    if (modal_calendar_year.data.visible) {
      if (
        modal_calendar_year.data.date[modal_calendar_year.data.type] ||
        modal_calendar_year.data.date[modal_calendar_year.data.type] === null
      ) {
        setValue(modal_calendar_year.data.date[modal_calendar_year.data.type]);
        setLocaleDate(setLocaleDateString(modal_calendar_year.data.date[modal_calendar_year.data.type], 'kor'));

        if (modal_calendar_year.data.time && modal_calendar_year.data.date[modal_calendar_year.data.type] !== null) {
          const cur_hours = Number(modal_calendar_year.data.date[modal_calendar_year.data.type]?.getHours());
          const cur_minutes = Number(modal_calendar_year.data.date[modal_calendar_year.data.type]?.getMinutes());

          setHours(`${cur_hours < 10 ? `0${cur_hours}` : cur_hours}시`);

          const tmp_minutes = Math.ceil(cur_minutes / 5) * 5;
          setMinutes(`${tmp_minutes < 10 ? `0${tmp_minutes}` : tmp_minutes}분`);
        }
      }
      setView(modal_calendar_year.data.openTo);
    } else {
      setModalTimeVisible(false);
      setHours('00시');
      setMinutes('00분');
    }
  }, [modal_calendar_year.data.visible]);

  useEffect(() => {
    if (localeDate) {
      setCurYear(localeDate.slice(0, 4));
    }
  }, [localeDate]);

  const handleChange = (date: Date | null | unknown, type: string) => {
    if (view === 'year') {
      setValue(date);
      setLocaleDate(setLocaleDateString(date as Date | null, 'kor'));
    }
    if (view === 'month') {
      setValue(date);
      setLocaleDate(setLocaleDateString(date as Date | null, 'kor'));
      if (modal_calendar_year.data.type === 'att_status' && date instanceof Date) {
        setLocaleDate(setLocaleDateString(date as Date | null, 'kor'));
        modal_calendar_year.data.date[modal_calendar_year.data.type] = date;
        onCloseModal();
      }
    }
    if (view === 'day') {
      if (type == 'date') {
        setLocaleDate(setLocaleDateString(new Date(`${date}`), 'kor'));
        if (modal_calendar_year.data.time) {
          setModalTimeVisible(true);
        } else {
          if (modal_calendar_year.data.key && modal_calendar_year.data.key == 'billing_format') {
            const select_date = setLocaleDateString(date as Date, '-');
            const today = dayjs().format('YYYY-MM-DD');

            if (select_date == today && modal_calendar_year.data.callback) {
              modal_calendar_year.data.callback();
              setValue(null);
              setStatActive(false);
            } else {
              modal_calendar_year.setModalCalendarDataDateType(new Date(`${date}`), modal_calendar_year.data.type);
              setValue(null);
              setStatActive(false);
              setView('year');
              modal_calendar_year.closeModalCalendar();
            }
          } else if (modal_calendar_year.data.type != 'accountStatisticsStart') {
            modal_calendar_year.setModalCalendarDataDateType(new Date(`${date}`), modal_calendar_year.data.type);
            setView('year');
            setValue(null);
            setStatActive(false);
            modal_calendar_year.closeModalCalendar();
          } else {
            setStatActive(true);
            setValue(date);
            setLocaleDate(setLocaleDateString(date as Date | null, 'kor'));
          }
        }
      }
    }
  };

  const onSettingView = (type: string) => {
    if (type.includes('년')) {
      setView('year');
    } else if (type.includes('월')) {
      setView('month');
    } else {
      setView('day');
    }
    setModalTimeVisible(false);
  };

  const onCloseModal = () => {
    if (modalTimeVisible) {
      const cur_date_kor = `${localeDate}`.replace(/[^0-9]/gi, '');
      const cur_date = `${cur_date_kor.slice(0, 4)}-${cur_date_kor.slice(4, 6)}-${cur_date_kor.slice(6, 8)}`;
      const cur_hours = hours.replace(/[^0-9]/gi, '');

      modal_calendar_year.setModalCalendarDataDateType(
        new Date(`${cur_date} ${cur_hours}:${minutes.replace(/[^0-9]/gi, '')}:00`),
        modal_calendar_year.data.type,
      );
      setView('year');
      setValue(null);
    }
    setView('year');
    setStatActive(false);
    modal_calendar_year.closeModalCalendar();
  };

  const selectTime = (type: string, value: string) => {
    if (type == 'hours') {
      setHours(`${value}시`);
    } else {
      setMinutes(`${value}분`);
    }
  };

  return (
    <>
      <ModalDefault visible={modal_calendar_year.data.visible} onClose={onCloseModal}>
        <StyledModalCalendar>
          <StyledTitle>
            <Box component={'h4'} sx={{ color: 'gray_3.main' }}>
              {curYear}
            </Box>
            <Box component={'h2'} sx={{ cursor: 'pointer' }}>
              {localeDate.split(' ').map((item, idx) => (
                <Box component={'span'} key={`date_item_${idx}`} onClick={() => onSettingView(item)}>
                  {item}{' '}
                </Box>
              ))}
            </Box>
          </StyledTitle>
          {modalTimeVisible ? (
            <Box className='timebox_wrap'>
              <Box className='timebox'>
                <Button id='hours_menu' onClick={() => false} disableRipple variant='outlined' color='black_4'>
                  {hours}
                </Button>
                <Button id='minutes_menu' onClick={() => false} disableRipple variant='outlined' color='black_4'>
                  {minutes}
                </Button>
              </Box>
              <Box className='time_contents_box'>
                {/* <Box className='time_contents'>
                  {time_arr.map((item, item_idx) => {
                    const active = time == item;

                    return (
                      <Button
                        variant={active ? 'contained' : 'text'}
                        color={active ? 'calendar_red' : 'black_4'}
                        key={`time_contents_time_${item_idx}`}
                        onClick={() => selectTime('time', item)}
                      >
                        {item}
                      </Button>
                    );
                  })}
                </Box> */}
                <Box className='time_contents'>
                  {hours_arr.map((item, item_idx) => {
                    const active = hours == `${item}시`;
                    return (
                      <Button
                        variant={active ? 'contained' : 'text'}
                        color={active ? 'calendar_red' : 'black_4'}
                        key={`time_contents_hours_${item_idx}`}
                        onClick={() => selectTime('hours', item)}
                      >
                        {item}시
                      </Button>
                    );
                  })}
                </Box>
                <Box className='time_contents'>
                  {minutes_arr.map((item, item_idx) => {
                    const active = minutes == `${item}분`;
                    return (
                      <Button
                        variant={active ? 'contained' : 'text'}
                        color={active ? 'calendar_red' : 'black_4'}
                        key={`time_contents_minutes_${item_idx}`}
                        onClick={() => selectTime('minutes', item)}
                      >
                        {item}분
                      </Button>
                    );
                  })}
                </Box>
              </Box>
            </Box>
          ) : (
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <CustomDatePicker
                openTo='year'
                views={['year', 'month', 'day']}
                view={view}
                minDate={modal_calendar_year.data.min ? modal_calendar_year.data.min : new Date('1950-01-01')}
                maxDate={modal_calendar_year.data.max ? modal_calendar_year.data.max : new Date()}
                date={value}
                onYearChange={() => setView('month')}
                onMonthChange={() => setView('day')}
                onChange={(date: Date | null | unknown) => handleChange(date, 'date')}
                className={
                  statActive && modal_calendar_year.data.type == 'accountStatisticsStart'
                    ? 'account_stat'
                    : 'default_day'
                }
                allowSameDateSelection
              />
            </LocalizationProvider>
          )}

          {view == 'day' && statActive && modal_calendar_year.data.type == 'accountStatisticsStart' ? (
            <Box sx={{ display: 'flex', width: '100%', minHeight: '2.5rem', marginBottom: '-2px' }}>
              <Button
                color='green'
                variant='outlined'
                onClick={() => {
                  modal_calendar_year.setModalCalendarDataDateType(
                    new Date(`${setLocaleDateString(new Date(value as Date), '-')} 12:45:45`),
                    'accountStatisticsStart',
                  );
                  modal_calendar_year.setModalCalendarDataDateType(new Date(`${value}`), 'accountStatisticsEnd');
                  onCloseModal();
                }}
                sx={{ pt: '1rem', pb: '1rem', width: 1, borderRadius: 0, height: '100%' }}
              >
                일자별 조회
              </Button>
              <Button
                color='green'
                variant='contained'
                onClick={() => {
                  modal_calendar_year.setModalCalendarDataDateType(
                    new Date(`${setLocaleDateString(new Date(value as Date), '-')} 09:00:00`),
                    modal_calendar_year.data.type,
                  );
                  onCloseModal();
                }}
                sx={{ pt: '1rem', pb: '1rem', width: 1, borderRadius: 0, height: '100%' }}
              >
                시작일 설정
              </Button>
            </Box>
          ) : (
            <Button
              color={modalTimeVisible ? 'green' : 'black'}
              variant={modalTimeVisible ? 'contained' : 'text'}
              onClick={onCloseModal}
              sx={{ pt: '1rem', pb: '1rem', width: 1, borderRadius: modalTimeVisible ? '0' : '4px' }}
            >
              {modalTimeVisible ? '확인' : '취소'}
            </Button>
          )}
        </StyledModalCalendar>
      </ModalDefault>
    </>
  );
}

export default ModalCalendarStudent;
